import { Component, computed, input, model, output, signal } from "@angular/core";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { TagModule } from "primeng/tag";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IViolationReport, ModerationAction, ModerationActionPayload } from "../../../../Utils/_models/voilation-reports.model";
import { SelectModule } from "primeng/select";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputTextModule } from "primeng/inputtext";
import { TooltipModule } from "primeng/tooltip";
import { TextareaModule } from "primeng/textarea";
import { MultiSelectModule } from "primeng/multiselect";
import { ModerationActionFormComponent, ModerationActionPayload as SharedActionPayload } from "../../../../shared/components/moderation-action-form/moderation-action-form.component";

 
@Component({
  selector: "app-voilation-details-modal",
  standalone: true,
  imports: [
      CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    TagModule,
    RadioButtonModule,
    InputTextModule,
    SelectModule,
    TooltipModule,
    TextareaModule,
    MultiSelectModule,
    ModerationActionFormComponent
  ],
  templateUrl: "./voilation-details-modal.component.html",
  styleUrl: "./voilation-details-modal.component.css"
})
export class VoilationDetailsModalComponent {
  report = input<IViolationReport | null>(null);
  visible = model<boolean>(false);
  onClose = output();
  onAction = output<ModerationActionPayload>();
 
  handleAction(payload: SharedActionPayload) {
    const reportData = this.report();
    if (!reportData) return;

    const actionPayload: ModerationActionPayload = {
      action: payload.action,
      report: reportData,
      reason: payload.reason,
      emailSubject: payload.emailSubject,
      emailBody: payload.emailBody,
      suspendedServices: payload.suspendedServices,
      suspendDays: payload.suspendDays
    };
 
    this.onAction.emit(actionPayload);
    this.closeDialog();
  }

  closeDialog(): void {
    this.visible.set(false);
    this.onClose.emit();
  }

  getStatusSeverity(status: string): string {
    switch (status) {
      case "Pending": return "p-tag-warning";
      case "Under Review": return "p-tag-success";
      case "Suspended": return "p-tag-danger";
      default: return "p-tag-info";
    }
  }
 
  getReasonSeverity(reason: string): string {
    switch (reason) {
      case "Harassment": return "p-tag-danger";
      case "Spam": return "p-tag-success";
      case "Inappropriate Content": return "p-tag-danger";
      default: return "p-tag-info";
    }
  }

  isPdf(url: string): boolean {
    if (!url) return false;
    // Extract everything before any query parameters
    const urlWithoutQuery = url.split('?')[0].toLowerCase();
    return urlWithoutQuery.endsWith('.pdf');
  }

  getSeverityLevel(count: number | undefined): { label: string; class: string } {
    const total = count || 1;
    if (total < 5) return { label: 'Low', class: 'p-tag-success' };
    if (total < 15) return { label: 'Medium', class: 'p-tag-warning' };
    return { label: 'High', class: 'p-tag-danger' };
  }
}
 